// @ts-nocheck
import { History, Location } from 'history';
import hoistNonReactStatics from 'hoist-non-react-statics';
import isEqual from 'lodash/isEqual';
import { SimpleCallback } from 'platform-components';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { matchPath } from 'react-router-dom';

interface Props {
    applyFilterFromUrl: (history: History) => void;
    filterValues: Record<string, Array<string> | string>;
    history: History;
    themeId: number;
}

export default function withUrlFilterListening<T extends Props>(WrappedComponent: React.ComponentType<T>) {
    class WithUrlFilterListening extends React.Component<T> {
        static displayName = `WithUrlFilterListening(${WrappedComponent.displayName})`;
        static contextTypes = {
            // eslint-disable-next-line react/forbid-prop-types
            staticUrls: PropTypes.object.isRequired,
        };

        componentDidMount() {
            const { applyFilterFromUrl, history } = this.props;
            const { staticUrls } = this.context;

            // @ts-ignore @todo починить типы (приходит `Location`, а в типах указан `Update`)
            this.unlisten = history.listen((location: Location) => {
                const { filterValues } = this.props;
                const match = matchPath(location.pathname, { path: staticUrls.labLibrarySubjectThemeStacks });

                let filterFromUrl = {};
                let hasFiltersChanged = false;
                const params = qs.parse(history.location.search, { arrayFormat: 'bracket' });
                const { filter } = params;

                try {
                    filterFromUrl = JSON.parse(filter);
                } catch {
                    // Ignore JSON.parse error
                } finally {
                    const hasFilters = typeof filter !== 'undefined';
                    hasFiltersChanged = !isEqual(filterFromUrl, filterValues) && hasFilters;
                }

                if (match && hasFiltersChanged) {
                    applyFilterFromUrl(this.props.history);
                }
            });
        }

        componentWillUnmount() {
            this.unlisten();
        }

        unlisten: SimpleCallback;

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    return hoistNonReactStatics(WithUrlFilterListening, WrappedComponent) as React.ComponentType<Omit<T, keyof Props>>;
}
